var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.61964 4.96767L9.34882 2.32653C9.68373 2.00242 9.68373 1.47694 9.34882 1.15257L8.74227 0.565589C8.40736 0.241483 7.86436 0.241483 7.52918 0.565589L4.8 3.20673L2.07082 0.565589C1.73591 0.241483 1.19291 0.241483 0.857727 0.565589L0.251182 1.15257C-0.0837273 1.47667 -0.0837273 2.00216 0.251182 2.32653L2.98036 4.96767L0.251182 7.60881C-0.0837273 7.93292 -0.0837273 8.4584 0.251182 8.78277L0.857727 9.36975C1.19264 9.69386 1.73591 9.69386 2.07082 9.36975L4.8 6.72861L7.52918 9.36975C7.86409 9.69386 8.40736 9.69386 8.74227 9.36975L9.34882 8.78277C9.68373 8.45867 9.68373 7.93318 9.34882 7.60881L6.61964 4.96767Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.376a09dac9c49a0685bdbe6b6045b198.svg";
export { ForwardRef as ReactComponent };